"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postAllAvailability = postAllAvailability;

var _endpoints = require("MeetingsLib/constants/endpoints");

function postAllAvailability(httpClient, data) {
  return httpClient.post(_endpoints.TEST_AVAILABILITY_ENDPOINT, {
    withCredentials: false,
    data: data
  });
}